import React from 'react'
import { useHistory } from 'react-router-dom'

interface props {
  setContent: React.Dispatch<React.SetStateAction<string>>
}

const Sidebar = ({ setContent }: props) => {
  const history: any = useHistory()

  const logout = (): void => {
    localStorage.removeItem('access')
    localStorage.removeItem('refresh')
    history.push({ pathname: '/admin/login' })
  }
  return (
    <>
      <div className='h-screen w-10/12 bg-viper grid justify-items-center'>
        <button
          className='w-full h-1/4 mt-5 panelbtn'
          onClick={() => setContent('clients')}>
          <img
            src='../user.png'
            alt='user icon'
            className='w-1/5 float-left ml-2'
          />
          <h2 className='text-white text-3xl mt-2 mr-11'>Clientes</h2>
        </button>

        <button
          className='w-full h-1/4 mt-5 panelbtn'
          onClick={() => setContent('payments')}>
          <img
            src='../income.png'
            alt='income icon'
            className='w-1/5 float-left ml-2'
          />
          <h2 className='text-white text-3xl mt-2 mr-16'>Pagos</h2>
        </button>

        <button
          className='w-full h-1/4 mt-5 panelbtn'
          onClick={() => setContent('locations')}>
          <img
            src='../direction.png'
            alt='direction icon'
            className='w-1/5 float-left ml-2'
          />
          <h2 className='text-white text-3xl mt-2'>Direcciones</h2>
        </button>

        <button
          className='w-full h-1/4 mt-5 panelbtn'
          onClick={() => setContent('methods')}>
          <img
            src='../credit-card-payment.png'
            alt='credit-card-payment icon'
            className='w-1/5 float-left ml-2'
          />
          <h2 className='text-white text-3xl mt-2 mr-10'>Métodos</h2>
        </button>

        <button
          className='w-full h-1/4 mt-5 panelbtn'
          onClick={() => setContent('reports')}>
          <img
            src='../report.png'
            alt='report icon'
            className='w-1/5 float-left ml-2'
          />
          <h2 className='text-white text-3xl mt-2 mr-8'>Reportes</h2>
        </button>

        <button className='w-full h-1/4 mt-28 panelbtn' onClick={logout}>
          <img
            src='../logout.png'
            alt='logout icon'
            className='w-1/5 float-left ml-2'
          />
          <h2 className='text-white text-3xl mt-2 mr-24'>Salir</h2>
        </button>
      </div>
    </>
  )
}

export default Sidebar
